import { ShieldCheck, Handshake, Globe2, Leaf } from "lucide-react";
import { aboutValues } from "@/data/site";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

const iconMap = { ShieldCheck, Handshake, Globe2, Leaf };

export default function About() {
  return (
    <section
      id="about"
      data-testid={IDS.aboutSection}
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left — heading */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
                About Us
              </span>
              <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-[1.08] tracking-tight text-ink">
                Your Trusted Export Partner{" "}
                <span className="font-serif-accent italic font-medium text-brand">
                  from India
                </span>
              </h2>
              <p className="mt-6 text-mist leading-relaxed text-base sm:text-lg">
                We are an Indian merchant export company specializing in
                sustainable packaging products. Rather than manufacturing
                ourselves, we collaborate with carefully selected and verified
                manufacturing partners across India to deliver quality,
                consistency and a reliable global supply chain.
              </p>
              <ul className="mt-8 space-y-3 text-ink">
                {[
                  "Consistent quality across every shipment",
                  "Competitive export pricing",
                  "Reliable, capacity-checked production",
                  "International shipping support",
                  "Long-term business partnerships",
                ].map((li) => (
                  <li key={li} className="flex items-start gap-3">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-brand shrink-0" />
                    <span>{li}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          {/* Right — numbered manifesto chapters */}
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-x-10">
            {aboutValues.map((v, i) => {
              const Icon = iconMap[v.icon];
              return (
                <Reveal
                  key={v.title}
                  delay={i * 0.08}
                  className="group relative border-t border-line py-9"
                >
                  <span className="pointer-events-none absolute right-0 top-5 font-heading text-6xl font-bold text-brand/10 transition-colors duration-500 group-hover:text-brand/25 select-none">
                    0{i + 1}
                  </span>
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sage text-forest transition-colors duration-500 group-hover:bg-brand group-hover:text-white">
                    <Icon className="h-5 w-5" strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-5 font-heading text-xl font-semibold text-ink">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-sm text-mist leading-relaxed max-w-xs">
                    {v.body}
                  </p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
